package com.bikompanion.domain.usecase

import dev.zacsweers.metro.Inject
import com.bikompanion.domain.BikeStation
import com.bikompanion.domain.BikeType
import com.bikompanion.domain.StationWatch
import com.bikompanion.domain.StationWatchRepository
import com.bikompanion.domain.analytics.AnalyticsTracker
import com.bikompanion.domain.analytics.DomainAnalyticsEvents
import kotlin.time.Duration.Companion.minutes

/** How long a watch keeps looking before it gives up. The expiry notifications name this length. */
internal val StationWatchDuration = 30.minutes

@Inject
class StartStationWatchUseCase(
    private val repository: StationWatchRepository,
    private val analytics: AnalyticsTracker,
) {
    operator fun invoke(
        station: BikeStation,
        bikeType: BikeType,
        nowEpochMillis: Long,
    ): StationWatch {
        val watch = StationWatch(
            networkId = station.networkId,
            stationId = station.id,
            stationName = station.name,
            bikeType = bikeType,
            expiresAtEpochMillis = nowEpochMillis + StationWatchDuration.inWholeMilliseconds,
            station = station,
        )
        repository.replace(watch)
        analytics.track(DomainAnalyticsEvents.stationWatchStarted(watch))
        return watch
    }
}
